import React from "react";
import ReactEcharts from "echarts-for-react";
import { Background } from "victory";

  function GraphCamembergRDTMildiou({myData}) { 
    const colorMap = {
        'Pertes Climatique': '#5FC1AA',  // Tomate
        'Pertes Milidou': '#247E5F',     // Vert clair
        'Récolte résiduelle': '#B2E1C7', // Bleu
      };
    const getOptions = () => {
      let options = {
        series: [
          {
            name: "Pertes de rendement",
            type: "pie",
            radius: '90%',
            center: ["50%", "50%"],
            data: myData.map(item => ({
                ...item,
                itemStyle: {
                  color: colorMap[item.name] || '#000000', // Associe la couleur selon le name, sinon noir par défaut
                },
              })),
            label: {
                position: "inside",
                formatter: "{all|{c} %}", // Utilise le style nommé "value"
                rich: {
                    all: {
                    fontSize: 35,
                    color: "black", 
                    fontWeight: "bold",
                    backgroundColor: "white",
                    padding: [15, 10], // Ajoute de l'espace autour du texte
                    borderRadius: 10, // Arrondi les coins du fond
                    },
                },
            }
          }
        ]
      };
  
      return options;
    };
  

    return (
      <div style={{marginBottom:"20px", width:  '100%', height: '425px'}}>
        <ReactEcharts option={getOptions()} style={{ height: '100%', width:'100%' }} />
    </div>
  
  );
}

export default GraphCamembergRDTMildiou;
  